import { ValidationDto } from './';

export class ValidationTypeDto {
    validationTypeId: number;
    validationTypeName: string;
    validations: ValidationDto[]=[];
}